export const comparisonSliderConfigSchema = {
  type: 'object',
  properties: {
    edge: { type: 'number' },
    start: { type: 'number' },
    vertical: { type: 'boolean' }
  }
}
